import { computed } from '#imports'
import { useTermsDialog } from './useTermsDialog'

export function usePromotionTermsQueries(brand: string) {
    const { terms, generalTerms, privacyPolicy, promotionId, bonusCode, bundleId, promotionReferenceId, bonusReferenceId, excludedGames, bingoGames, isPromotionTerms, isActive } = useTermsDialog()

    const key = computed(() => {
        if (excludedGames.value) return 'promotion:terms-excluded-games'
        if (bingoGames.value) return 'promotion:terms-bingo-games'
        if (bonusCode.value) return `bonus:terms-${bonusCode.value}`
        if (bundleId.value) return `bundle:terms-${bundleId.value}`
        if (promotionId.value) return `promotion:terms-${promotionId.value}`
        if (promotionReferenceId.value) return `promotion:promotion-terms-${promotionReferenceId.value}`
        if (bonusReferenceId.value) return `promotion:bonus-terms-${bonusReferenceId.value}`

        return 'promotion:no-terms'
    })

    const endpointUrl = computed(() => {
        if (excludedGames.value) {
            return `/rewards/excluded_games_terms?brand=${brand}`
        }

        if (bingoGames.value) {
            return `/rewards/bingo_games_terms?brand=${brand}`
        }

        if (bonusCode.value) {
            return `/bonus_offers/bonus_info/${bonusCode.value}`
        }

        if (promotionId.value) {
            return `/rewards/terms/${promotionId.value}`
        }

        if (bundleId.value) {
            return `/rewards/bundle_terms/${bundleId.value}`
        }

        return ''
    })

    const promotionTermsEnabled = computed(() => Boolean(bonusCode.value || promotionId.value || bundleId.value))
    const excludedGamesTermsEnabled = computed(() => Boolean(excludedGames.value))
    const bingoGamesTermsEnabled = computed(() => Boolean(bingoGames.value))
    const monolithTermsEnabled = computed(() => promotionTermsEnabled.value || excludedGamesTermsEnabled.value || bingoGamesTermsEnabled.value)
    const promotionReferenceTermsEnabled = computed(() => Boolean(promotionReferenceId.value) && !excludedGamesTermsEnabled.value && !bingoGamesTermsEnabled.value)
    const bonusReferenceTermsEnabled = computed(() => Boolean(bonusReferenceId.value) && !excludedGamesTermsEnabled.value && !bingoGamesTermsEnabled.value)
    const generalTermsEnabled = computed(() => (!!terms.value || !!generalTerms.value) && !isPromotionTerms.value && !excludedGamesTermsEnabled.value && !bingoGamesTermsEnabled.value && !privacyPolicy.value)
    const privacyPolicyEnabled = computed(() => !!privacyPolicy.value)

    return {
        terms,
        generalTerms,
        privacyPolicy,
        promotionId,
        bonusCode,
        bundleId,
        promotionReferenceId,
        bonusReferenceId,
        excludedGames,
        bingoGames,
        isPromotionTerms,
        isActive,
        key,
        endpointUrl,
        monolithTermsEnabled,
        promotionTermsEnabled,
        excludedGamesTermsEnabled,
        bingoGamesTermsEnabled,
        promotionReferenceTermsEnabled,
        bonusReferenceTermsEnabled,
        generalTermsEnabled,
        privacyPolicyEnabled,
    }
}
